import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import defaultLang from '../../language';

function Error() {
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );

    return (
        <>
            <Header title={defaultLang.header.fullName} />
            <Helmet>
                <title>Business Product Selector | U.S. Bank</title>
            </Helmet>
            <main id="app__content">
                <div className="main-content-wrapper">
                    <div className="main-left-content">
                        <h1>
                            <legend>
                                {' '}
                                Sorry, this wasn't supposed to happen.
                            </legend>
                        </h1>
                        <div>
                            <p className="p-content">
                                There's a technical issue on our end.
                                Please go back to your Salesforce
                                relationship page and try again.
                            </p>
                        </div>
                    </div>
                    <div className="main-right-content" />
                </div>
            </main>
            <Footer
                header={defaultLang.footer.connectionTitle}
                content={defaultLang.footer.footerDisclosure}
                privacyLabel={AEMContent.footer.privacyLabel}
                privacyUrl={AEMContent.footer.privacyUrl}
                fdic={defaultLang.footer.connectionContent}
                cobrowseLabel={AEMContent.footer.cobrowseLabel}
                cobrowseUrl={AEMContent.footer.cobrowseUrl}
            />
        </>
    );
}

export default Error;
